export const waitForImagesToLoad = (root: HTMLElement, timeoutMs = 10000): Promise<void> => {
  const images = Array.from(root.querySelectorAll('img')) as HTMLImageElement[];
  if (images.length === 0) return Promise.resolve();

  const imagePromises = images.map(img => {
    if (img.complete && img.naturalWidth > 0) return Promise.resolve();
    return new Promise<void>(resolve => {
      const onDone = () => {
        img.removeEventListener('load', onDone);
        img.removeEventListener('error', onDone);
        resolve();
      };
      img.addEventListener('load', onDone, { once: true });
      img.addEventListener('error', onDone, { once: true });
    });
  });

  const timeout = new Promise<void>(resolve => setTimeout(resolve, timeoutMs));
  return Promise.race([Promise.all(imagePromises).then(() => {}), timeout]);
};
